import React from "react";
import {DataBaseComponent, DataBaseComponentState} from "../../components/DataBaseComponent";
import SaveDialogLayout from "../../components/DialogLayout/SaveDialogLayout";
import {Text} from "components/form";
import {getRememberedJustification} from "../../client/rememberedJustification";

// Mirrors the server-side [Required, MinLength(5)] rule on the justification.
// source/CloudPortal.Web/Features/Files/FilesController.cs
// source/CloudPortal.Web/Features/Instances/DiagnosticFileController.cs
const minimumJustificationLength = 5;

interface DownloadFileDialogProps {
    title: string;
    getDownloadUrl(justification: string): string;
}

interface DownloadFileDialogState extends DataBaseComponentState {
    Justification: string;
}

export class DownloadFileDialog extends DataBaseComponent<DownloadFileDialogProps, DownloadFileDialogState> {
    constructor(props: DownloadFileDialogProps) {
        super(props);
        this.state = {
            Justification: getRememberedJustification()
        }
    }

    render() {
        return <SaveDialogLayout title={this.props.title}
                                 busy={this.state.busy}
                                 errors={this.state.errors}
                                 saveButtonLabel={"Download"}
                                 cancelButtonLabel={"Cancel"}
                                 onSaveClick={() => this.download()}>

            <Text label="Justification"
                  hintText="Link to email, support ticket, explanation of issue, etc."
                  value={this.state.Justification}
                  onChange={Justification => this.updateJustification(Justification)}
                  error={this.getFieldError("Justification")}
            />

        </SaveDialogLayout>;
    }

    private download = async (): Promise<boolean> => {
        if (this.state.Justification.length < minimumJustificationLength) {
            this.setError("Please provide a justification.", [], {
                Justification: `Justification must be at least ${minimumJustificationLength} characters.`
            });
            return false;
        }

        window.open(this.props.getDownloadUrl(this.state.Justification));
        return true;
    };

    private updateJustification(update: string) {
        return this.setState(_ => ({Justification: update}));
    }
}
